export default {
  RECOMMEND: {
    GET_ARTICLES_SUCCESS: 'recommend/get_articles_success',
    GET_BACK_NEWS_SUCCESS: 'recommend/get_back_news_success',
    LOAD_MORE_ARTICLES: 'recommend/load_more_articles',
    GET_INTEREST_RECOMMEND_SUCCESS: 'recommend/get_interest_recommend_success',
  },
  COMMENT: {
    GET_HOT_COMMENT: 'comment/get_hot_comment',
    GET_HOT_COMMENT_NEW: 'comment/get_hot_comment_new'
  },
  DOWNLOADBAR: {
    DOWNLOAD_SCENE: 'download_bar/download_scene',
    DOWNLOAD_STATUS: 'download_bar/download_status',
    PROGRESS_VALUE: 'download_bar/progress_value',
    BAR_ACTIVE: 'download_bar/bar_active'
  },
  COMMON: {
    GET_PARAMS: 'common/get_params',
    SHARE_WECHAT_DIALOG: 'common/share_wechat_dialog',
    PAGE_STATE: 'common/page_state',
    END_CONTENT_UPDATE_LINKURL : 'common/update_end_content_linkurl'
  },
  USERINFO: {
    GET: 'userinfo/get'
  },
  ARTICLE: {
    GET: 'article/get'
  },
  DIALOG: {
    SYS_DIALOG: 'dialog/sys_dialog',
    SMP_DIALOG: 'dialog/smp_dialog',
    WELFARE_DIALOG: 'dialog/welfare_dialog',
    COLLAPSED: 'dialog/collapsed',
    SYS_DIALOG_ACTIVE_APP: 'dialog/sys_dialog_active_app',
    CANCEL_INSTALL_DIALOG: 'dialog/cancel_install_dialog'
  },
  SMP: {
    GET_SMP_UI_DATA: 'smp/getSmpUIData'
  },
  SEARCH: {
    GET_HOT_RANK: 'searcb/hotRank/get'
  },
  VIDEO: {
    GET_VIDEO_INFO: 'video/get_video_info',
    GET_MINI_VIDEO_COLLECTION: 'video/get_mini_video_collection',
    GET_RECOMMEND_VIDEO: 'video/get_recommend_video',
    VIDEO_TIME: 'video/video_time',
    SHARE_WECHAT_DIALOG: 'video/share_wechat_dialog',
  },
  SHORT_CONTENT: {
    CONTENT: 'shortcontent/content'
  },
  RECOMMEND_POP: {
    SET_STATUS: 'recommend/pop'
  },
  SECOND_SHARE: {
    SHARE_POP: 'secondshare/pop'
  },
  E_COMMERCE_FISSION: {
    CLIPBOARD: 'clipboard/get_clipboard',
    ACTIVITY_DATA: 'activity/get_activity',
    COMMODITY_DETAIL: 'activity/get_commodity',
    DIALOG: 'activity/dialog'
  }
}
